// @ts-nocheck
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss, { StyledProp } from "@insite/mobius/utilities/InjectableCss";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export interface FiltersProps {
    borderCss?: StyledProp;
    borderWidth?: string;
    flatSection?: InjectableCss;
    flatSpacing?: string;
    section?: InjectableCss;
    spacing?: string;
    title?: TypographyPresentationProps;
    titleSpacing?: string;
}

const spacing = pxToRem(18);
const flatSpacing = pxToRem(24);
const titleSpacing = pxToRem(8);
const borderWidth = pxToRem(1);
const borderCss = css`
    ${({ theme }) => `${borderWidth} solid ${resolveColor("common.border", theme)}`}
`;

const getSectionProps = (_spacing: string): FiltersProps["section"] => ({
    css: css`
        ${spacingStyles(null, spacing)}
        padding-bottom: ${_spacing};
        border-bottom: ${borderCss};
    `,
});

export const filtersProps: FiltersProps = {
    borderCss,
    borderWidth,
    flatSection: getSectionProps(flatSpacing),
    flatSpacing,
    section: getSectionProps(spacing),
    spacing,
    title: {
        forwardAs: "h4",
        css: css`
            display: flex;
            margin-bottom: ${titleSpacing};

            ${({ theme }) => css`
                font-size: ${theme.design.typography.size.base};
                font-weight: ${theme.design.typography.weight.bold};
                line-height: ${theme.design.typography.lineHeight.semi};
            `}
        `,
    },
    titleSpacing,
};
